import * as React from "react";

export interface IErrorProps {
  error: string;
}

export const ErrorView = (props: IErrorProps) => {
  return (
    <span className="input__error alert error-text" role="alert">
      {props.error}
    </span>
  );
};
